import React from 'react';

/**
 * Vipps brand icon — white rounded-square background with the orange
 * "smile" and dot glyph. 24x24 by default; size scales via the SVG
 * viewBox so a CSS width/height override works as expected.
 * `inverted`: an orange disc with a white smile, for a white button.
 *
 * Sourced from Figma node 502:129.
 */
const IconVipps = props => (
  <svg
    className={props.className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      width="24"
      height="24"
      rx={props.inverted ? 12 : 8}
      fill={props.inverted ? '#FF5B24' : 'white'}
    />
    <path
      d="M12.351 15.2727C14.5392 15.2727 15.7812 14.1818 16.964 12.606C17.6146 11.7576 18.4426 11.5758 19.034 12.0606C19.6254 12.5455 19.6845 13.4545 19.034 14.303C17.3189 16.6061 15.1306 18 12.351 18C9.3347 18 6.67332 16.303 4.83992 13.3333C4.30764 12.5455 4.42593 11.697 5.01735 11.2727C5.60877 10.8485 6.49589 11.0303 7.02817 11.8788C8.32928 13.8788 10.1036 15.2727 12.351 15.2727ZM16.4317 7.81818C16.4317 8.90909 15.6038 9.63638 14.6575 9.63638C13.7112 9.63638 12.8832 8.90909 12.8832 7.81818C12.8832 6.72727 13.7112 6 14.6575 6C15.6038 6 16.4317 6.78788 16.4317 7.81818Z"
      fill={props.inverted ? 'white' : '#FF5B24'}
    />
  </svg>
);

export default IconVipps;
